import type { BaseAppProps } from '@shared/common/app/domain/type/base-app-props.type';
import { ContainerModule } from 'inversify';
import { container } from '@shared/common/dependency-injection/domain/container';
import { HostDependencyTypes } from '@shared/common/host/host.dependency-types';
import { MissingHostConfigurationError } from '@shared/common/host/domain/error/missing-host-config.error';

let hostContainerModule: ContainerModule | null = null;

const ensureHost = (value: string | undefined, name: string): string => {
  if (!value) {
    throw new MissingHostConfigurationError(name);
  }

  return value;
};

export const loadHostContainerModule = (appProps: BaseAppProps) => {
  if (hostContainerModule !== null) {
    return;
  }

  hostContainerModule = new ContainerModule((options) => {
    options.bind<string>(HostDependencyTypes.HubHost).toConstantValue(ensureHost(appProps.hubHost, 'hubHost'));
    options
      .bind<string>(HostDependencyTypes.MessagingHost)
      .toConstantValue(ensureHost(appProps.messagingHost, 'messagingHost'));
    options
      .bind<string>(HostDependencyTypes.AdventureHost)
      .toConstantValue(ensureHost(appProps.adventureHost, 'adventureHost'));
    options
      .bind<string>(HostDependencyTypes.ChallengeHost)
      .toConstantValue(ensureHost(appProps.challengeHost, 'challengeHost'));
    options.bind<string>(HostDependencyTypes.RacingHost).toConstantValue(ensureHost(appProps.racingHost, 'racingHost'));
    options.bind<string>(HostDependencyTypes.KwizHost).toConstantValue(ensureHost(appProps.kwizHost, 'kwizHost'));
    options
      .bind<string>(HostDependencyTypes.CockpitHost)
      .toConstantValue(ensureHost(window.location.origin, 'cockpitHost'));
  });

  container.load(hostContainerModule);
};

export { hostContainerModule };
